/**
 * Ayuda — Productos → Stock
 */

/** @type {import('../help-index.js').HelpSidebarItem} */
export const ADM_PRO_STOCK_ITEM = {
  id: 'stock',
  screenId: 'adm-pro-stock',
  label: 'Stock',
  description: 'Consultá y mové existencias por depósito.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Desde Stock controlás las existencias. Tiene cinco pestañas arriba; tocá cada una para cambiar de vista.',
      },
      {
        title: 'Las cinco pestañas',
        bullets: [
          'Movimientos — historial de entradas y salidas de un artículo en un depósito.',
          'Por Depósito — stock actual de todos los artículos en un depósito.',
          'Empaque — movimientos de empaque/desempaque y relaciones entre unidades (caja ↔ unidad).',
          'Mov entre Almacenes — traslados entre depósitos.',
          'Stock mínimo — alertas cuando el stock baja de un umbral.',
        ],
      },
      {
        title: 'Pestaña Movimientos',
        fields: [
          { label: 'Artículo', description: 'Buscá el producto. Obligatorio.' },
          { label: 'Depósito', description: 'Elegí el almacén. Obligatorio.' },
          { label: 'A fecha', description: 'Opcional: stock y movimientos hasta esa fecha.' },
          { label: 'Filtro avanzado', description: 'Tipo de movimiento para acotar la búsqueda.' },
          { label: 'Buscar', description: 'Muestra saldo actual y lista de movimientos con saldo acumulado.' },
        ],
        paragraphs: [
          'Tocá una fila para ver el detalle del comprobante que originó el movimiento.',
          'Botón + — cargar un ajuste manual de stock.',
        ],
      },
      {
        title: 'Pestaña Por Depósito',
        fields: [
          { label: 'Depósito', description: 'Almacén a consultar. Obligatorio.' },
          { label: 'Grupo de artículos', description: 'Filtrar por grupo (opcional).' },
          { label: 'A fecha', description: 'Stock a una fecha determinada (opcional).' },
          { label: 'Buscar', description: 'Lista artículo, descripción y cantidad.' },
        ],
        paragraphs: ['Tocá un artículo para ver sus movimientos en ese depósito.'],
      },
      {
        title: 'Pestaña Empaque',
        intro:
          'Tiene dos pestañas internas: Movimientos y Relaciones.',
        bullets: [
          'Movimientos — historial de empaque y desempaque (pasar de caja a unidades o al revés).',
          'Relaciones — equivalencias entre productos (por ejemplo 1 caja = 12 unidades). Conviene cargar las relaciones antes de registrar movimientos.',
        ],
      },
      {
        title: 'Empaque → Movimientos',
        intro:
          'Al abrir Empaque ves esta lista. Cada fila es un movimiento: qué artículo sale, qué artículo entra y en qué depósito.',
        bullets: [
          'Botón + — nuevo movimiento de empaque o desempaque.',
          'Ícono de basura — elimina el movimiento y revierte ambas cantidades de stock. Pedirá confirmación.',
        ],
        fields: [
          { label: 'Fecha desde / hasta', description: 'Filtrar por período (opcional).' },
          { label: 'Depósito', description: 'Acotar a un almacén o dejar todos.' },
          { label: 'Filtro artículo', description: 'Opcional: muestra movimientos de ese producto (sale o entra).' },
          { label: 'Buscar', description: 'Actualiza la lista con los filtros elegidos.' },
        ],
      },
      {
        title: 'Empaque → Relaciones',
        intro:
          'Define equivalencias entre productos. Sin una relación no se puede registrar un movimiento de empaque.',
        bullets: [
          'Botón + — alta de una equivalencia: artículo origen (empaque), artículo destino (contenido) y cantidad.',
          'Tocá una fila para editar la cantidad. El origen y el destino no se cambian.',
          'Ícono de basura — elimina la relación. Pedirá confirmación.',
        ],
        fields: [
          { label: 'Filtro artículo', description: 'Opcional: muestra solo relaciones de ese producto.' },
          { label: 'Buscar', description: 'Actualiza la lista con el filtro elegido.' },
        ],
      },
      {
        title: 'Pestaña Mov entre Almacenes',
        fields: [
          { label: 'Fecha Desde / Hasta', description: 'Filtrar traslados por período.' },
          { label: 'Depósito origen / destino', description: 'Acotar por depósitos.' },
          { label: 'Buscar', description: 'Lista de traslados realizados.' },
        ],
        paragraphs: [
          'Botón + — nuevo traslado: elegís origen, destino, artículos y cantidades.',
          'Tocá una fila para ver el detalle del movimiento.',
        ],
      },
      {
        title: 'Pestaña Stock mínimo',
        intro:
          'Reglas de stock bajo por artículo y depósito. La lista muestra artículo, depósito, cantidad mínima y si avisa.',
        bullets: [
          'Botón + — nueva regla: artículo, depósito, cantidad mínima y si querés notificación.',
          'Editar o eliminar reglas existentes desde la lista.',
        ],
      },
    ],
  },
}
